import { withNamespace } from "@/i18n/lazy-route"

/** Roles and the permission matrix (LLD §9.16, Task 2.4), with the `adminRoles` namespace. */
const translations = {
  en: () => import("@/i18n/locales/en/adminRoles.json"),
  fr: () => import("@/i18n/locales/fr/adminRoles.json"),
}

export const RoleListScreen = withNamespace(
  "adminRoles",
  () => import("./screens/RoleListScreen"),
  translations,
)
export const RoleEditorScreen = withNamespace(
  "adminRoles",
  () => import("./screens/RoleEditorScreen"),
  translations,
)
